import { Lock } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { usePermission } from '@/hooks/usePermission'
import { PERMISSION_KEYS } from '@/stores/permission.store'

/** Calling isn't on the workspace's plan (Basic): explain and point to the upgrade. */
export function CallingLockedCard() {
  const { can } = usePermission()
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-neutral-100">
          <Lock className="h-5 w-5 text-neutral-500" />
        </div>
        <div>
          <p className="font-semibold text-neutral-900">Calling is part of the Pro and Enterprise plans</p>
          <p className="mt-1 text-sm text-neutral-500">
            Call leads from their records, log every call automatically and track results.
          </p>
        </div>
        {can(PERMISSION_KEYS.SUBSCRIPTION_VIEW) ? (
          <Button asChild>
            <Link to="/subscription">See plans</Link>
          </Button>
        ) : (
          <p className="text-sm text-neutral-500">Ask your workspace owner to upgrade.</p>
        )}
      </CardContent>
    </Card>
  )
}
